import type { QueryClient, QueryKey } from '@tanstack/vue-query';
import { PriorityQueryKey, SectionQueryKey } from '@/modules/common/enums/query-key.enum.ts';
import {
  publishEntityUpdated,
  setupEntityUpdateSync,
  type ActiveEntityContext,
} from '@/modules/shared/composables/entity-update-sync.ts';

const ENTITY_TYPE = 'counterparty';

interface CounterpartyUpdateSyncOptions {
  getActiveCounterpartyContext?: (counterpartyId: number) => ActiveEntityContext | null;
}

function matchesCounterpartyUpdate(queryKey: QueryKey) {
  return queryKey[0] === PriorityQueryKey.Primary && queryKey[1] === SectionQueryKey.Counterparty;
}

export function publishCounterpartyUpdated(counterpartyId: number) {
  publishEntityUpdated(ENTITY_TYPE, counterpartyId);
}

export function setupCounterpartyUpdateSync(queryClient: QueryClient, options: CounterpartyUpdateSyncOptions = {}) {
  return setupEntityUpdateSync(queryClient, {
    entityType: ENTITY_TYPE,
    matchesQuery: matchesCounterpartyUpdate,
    getActiveEntityContext: options.getActiveCounterpartyContext,
  });
}
